import React, { useState } from "react";

function TermsAndConditionsModal({ isOpen, onClose, onAccept }) {
  const [hasAccepted, setHasAccepted] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-lg max-w-3xl w-full max-h-[90vh] flex flex-col">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-800">
            Terms and Conditions
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        <div className="flex-grow overflow-auto p-2">
          <iframe
            src="https://www.termsfeed.com/live/91f0a201-1fd7-485e-9cb6-f78c06048aa6"
            title="Terms and Conditions"
            className="w-full h-[60vh] border-0"
          />
        </div>

        <div className="p-4 border-t border-gray-200">
          <label className="flex items-center mb-4 cursor-pointer">
            <input
              type="checkbox"
              checked={hasAccepted}
              onChange={() => setHasAccepted(!hasAccepted)}
              className="h-5 w-5 text-[#23c55e] rounded border-gray-300 focus:ring-[#23c55e]"
            />
            <span className="ml-2 text-gray-700">
              I have read and agree to the Terms and Conditions
            </span>
          </label>

          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={onAccept}
              disabled={!hasAccepted}
              className={`px-4 py-2 rounded text-white ${
                hasAccepted
                  ? "bg-[#23c55e] hover:bg-[#1ea04d]"
                  : "bg-gray-400 cursor-not-allowed"
              }`}
            >
              Accept & Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditionsModal;
